import { gantt } from 'dhtmlx-gantt'

/**
 * Collapse all tasks in the gantt chart
 */
export const collapseAll = () => {
  gantt.eachTask((task) => {
    if (!task.parent || task.parent === 0 || task.parent === '0') {
      gantt.close(task.id)
    }
  })
}

/**
 * Expand only to categories level (parent tasks expanded, child tasks collapsed)
 */
export const expandToCategories = () => {
  gantt.eachTask((task) => {
    if (!task.parent || task.parent === 0 || task.parent === '0') {
      gantt.open(task.id)
    } else if (task.parent && task.parent !== 0 && task.parent !== '0') {
      gantt.close(task.id)
    }
  })
}

/**
 * Expand all tasks in the gantt chart
 */
export const expandAll = () => {
  gantt.eachTask((task) => {
    gantt.open(task.id)
  })
}

/**
 * Set active state for expand/collapse action buttons
 * @param {HTMLElement} container - The container element
 * @param {string} activeAction - The action that should be marked as active
 */
export const setExpandCollapseActiveButton = (container, activeAction) => {
  const actionButtons = container.querySelectorAll('[data-collapse-action]')

  actionButtons.forEach(btn => {
    const action = btn.getAttribute('data-collapse-action')
    if (action === activeAction) {
      btn.classList.add('active')
    } else {
      btn.classList.remove('active')
    }
  })
}